export default __webpack_public_path__ + "0b7d256b46ebd6cf1963a69fcfbafcfc.png";